import * as React from "react";

interface Props {
  style?: React.CSSProperties;
  className?: string;
}
export const PolicyIcon: React.FC<Props> = ({ style = {}, className = "" }) => {
  return (
    <svg
      style={style}
      className={className}
      id="bold"
      enableBackground="new 0 0 24 24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m14.25 0h-11.5c-1.52 0-2.75 1.23-2.75 2.75v15.5c0 1.52 1.23 2.75 2.75 2.75h8.15c-.84-1.33-1.4-2.9-1.4-4.7v-2.44c-.15.09-.32.14-.5.14h-5c-.55 0-1-.45-1-1s.45-1 1-1h5c.19 0 .36.05.51.14.04-.85.44-1.63 1.07-2.14h-6.58c-.55 0-1-.45-1-1s.45-1 1-1h9c.42 0 .78.26.93.63l2.85-.97c.07-.03.14-.05.22-.06v-4.85c0-1.52-1.23-2.75-2.75-2.75zm-6.25 6h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1z" />
      <path d="m23.322 11.339-5.25-1.786c-.209-.071-.436-.071-.645 0l-5.25 1.786c-.405.138-.678.519-.678.947v4.018c0 5.067 5.619 7.515 5.858 7.617.126.053.26.079.393.079s.267-.026.392-.08c.239-.102 5.858-2.549 5.858-7.616v-4.018c0-.429-.272-.809-.678-.947zm-2.022 3.761-3 4c-.174.232-.439.377-.729.397-.024.002-.048.003-.071.003-.265 0-.519-.104-.707-.293l-2-2c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l1.185 1.185 2.308-3.078c.331-.441.958-.532 1.399-.2.443.331.533.958.201 1.4z" />
    </svg>
  );
};
